import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import relativeTime from "dayjs/plugin/relativeTime";
import jalaliday from "jalali-plugin-dayjs";
import duration from "dayjs/plugin/duration";
// import isLeapYear from 'dayjs/plugin/isLeapYear'

dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(duration);
// dayjs.extend(isLeapYear)
dayjs.extend(jalaliday);
dayjs.extend((_option, Dayjs) => {
  Dayjs.prototype.jalaliFormat = function (format = "YYYY/MM/DD") {
    return this.calendar("jalali").locale("fa").format(format);
  };
});
// const reg = /(\d{4})-\d{1,2}-\d{1,2}/;
// dayjs.extend((option, Dayjs) => {
//   const proto = Dayjs.prototype;
//   const oldParse = proto.parse;
//   proto.parse = function (cfg) {
//     if (cfg.date && typeof cfg.date === 'string' && reg.test(cfg.date)) {
//       const res = reg.exec(cfg.date);
//       if (Number(res[1]) < 1600) cfg.jalali = true;
//     }
//     oldParse.bind(this)(cfg);
//   };
//   proto.standardFormat = function ({ jalali } = { jalali: false }) {
//     return this.calendar(jalali ? 'jalali' : 'gregory').format('YYYY-MM-DD');
//   };
// });
globalThis.dayjs = dayjs;
export default dayjs;
